<template>
  <div class="chat-message">

    <!-- My message -->
    <div class="message-containd message-contain--my" v-if="$slots['my']">
      <div class="message-nickname"  v-if="msg_type=='group'">
        <div class="role_tag role" :class="'role_'+role">{{ roles[role] }}</div>
        <div> {{ nickname }}</div>
      </div>
      <slot name="my"></slot>
    </div>

    <!-- Avatar -->
    <div class="chat-message-avatar">
      <el-avatar class="message-avatar"  :size="40" :src="avatar"></el-avatar>
    </div>

    <!-- His message -->
    <div class="message-contain message-contain--his" v-if="$slots['his']">
        <div class="message-nickname" v-if="msg_type=='group'">
          <div> {{ nickname }}</div>
          <div class="role_tag role" :class="'role_'+role">{{ roles[role] }}</div>
        </div>
      <slot name="his"></slot>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ChatMessage',

  props: {
    //会话类型
    msg_type:{
      type: String,
      default: 'private'
    },
    //消息用户角色
    role: {
      type: [String,Number],
      default: ''
    },
    //用户头像
    avatar: {
      type: String,
      default: ''
    },
    //用户昵称
    nickname: {
      type: String,
      default: ''
    }
  },
  data(){
    return{
      roles:{
        '1':'买家',
        '2':'卖家',
        '3':'官方'
      }
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.chat-message {
  //border: 1px solid #efefef;
  //border-radius: 10px;
  padding: 15px;
  display: inline-flex;

  .chat-message-avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .message-nickname {
    display: flex;
    align-items: center;
    height: 25px;
    font-size: 14px;
    //font-weight: bold;
    color: black;
  }
  .message-avatar img{
    width: 100% !important;

  }

  .message-contain {
    // padding: 10px 12px;
    // border-radius: 8px;
    // max-width: 1em * 32;
  }

  .message-containd {
    position: relative;
    border-radius: 8px;
    max-width: 1em * 32;
    display: flex;
    flex-direction: column;
  }

  .message-contain--my {
    margin-right: 10px;

    display: flex;
    flex-direction: column;
    align-items: flex-end;

    color: #FFFFFF;

    .message-nickname {
      text-align: right;
    }

    .role_tag {
      margin-left: 5px;
      font-size: 12px;
      color: red;
      border: 1px solid #fff;
      padding: 2px 5px;
      border-radius: 5px;
    }
    .role_1 {
      background-color: #007aff;
      color: #fff;
    }

    .role_2 {
      background: #31cb30;
      color: #fff;
    }
    .role_3 {
      font-size: 11px;
      box-sizing: border-box;
      height: 20px;
      border-radius: 5px;
      background-color: #f60;
      color: #fff;
    }
  }

  .message-contain--his {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .message-nickname {
      text-align: left;
    }

    .role_tag {
      margin-left: 5px;
      font-size: 12px;
      color: #f60;
      border: 1px solid #fff;
      border-radius: 5px;
    }

    .role{
      font-size: 11px;
      box-sizing: border-box;
      height: 20px;
      border-radius: 5px;
      padding: 2px 5px;
    }

    .role_1 {
      background-color: #007aff;
      color: #fff;
    }

    .role_2 {
      background: #31cb30;
      color: #fff;
    }
    .role_3 {
      font-size: 11px;
      box-sizing: border-box;
      height: 20px;
      border-radius: 5px;
      padding: 2px 5px;
      background-color: #f60;
      color: #fff;
    }
  }
}
.message-avatar {
  :deep(img){
    width: 100% !important;
  }
}
</style>
